import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  setting: {
    shortcuts: [],
    widgets: Array.from({ length: 8 }, (_, i) => ({ id: i.toString(), isActive: true })),
    mode: "white",
  },
  initialized: false,
  isTokenValid: false,
};

const user = createSlice({
  name: "user",
  initialState,
  reducers: {
    handleLogin(state, action) {
      if (state.data.length > 0) state.data = [];
      state.data.push(action.payload);
    },
    onClickLogout(state) {
      state.data.pop();
      sessionStorage.clear();
      localStorage.removeItem("user");
      state.setting = {};
      state.initialized = false;
      state.isTokenValid = false;
    },
    handleChangeUser(state, action) {
      const item = state.data[0];
      state.data = [{ ...item, ...action.payload }];
    },
    handleUpdateSetting(state, action) {
      state.setting = action.payload;
    },
    setInitialized(state, action) {
      state.initialized = action.payload;
    },
    setTokenValid(state, action) {
      state.isTokenValid = action.payload;
    },
  },
});

export const {
  handleLogin,
  onClickLogout,
  handleChangeUser,
  handleUpdateSetting,
  setInitialized,
  setTokenValid,
} = user.actions;

export default user;
